import Product from "./Product";

export default class Stack {
  constructor(product) {
    //always initiate with one product
    this.id = Math.floor(Math.random() * 9999999);
    this.products = product ? [product] : [];
    this.x = product.x;
    this.y = product.y;
    this.width = product.getWidth();
    this.height = product.depth;
  }

  updateCoordinates(x, y) {
    this.x = x;
    this.y = y;
    this.products.forEach(product => {
      product.x = x;
      product.y = y;
    });
  }

  toString(pallet) {
    if (!pallet.owned) {
      return "Fiktyvi";
    }
    if (!pallet.order_number) {
      return ""
    }
    const orders = pallet.order_number.split(",");
    let products = this.products.slice();
    this.products.sort((a, b) => {
      return a.z - b.z;
    });
    let text = "";
    if (products.length > 1) {
      products.forEach((product, i) => {
        const order = (orders.length > 1) ? product.order.toString() : "";
        text += `${order} Poz. ${product.position}`;
        if (products.length > 1 && i != products.length - 1) {
          text += " / ";
        }
      });
    } else {
      const order = (orders.length > 1) ? products[0].order.toString() : "";
      text = `${order} ${products[0].toString()}`;
    }
    return text;
  }

  addToStack(product) {
    product.x = this.products[0].x;
    product.y = this.products[0].y;
    this.products.push(product);
    this.products.sort((a, b) => {
      return a.z - b.z;
    })
  }

  getTop() {
    return this.products[0].y;
  }

  getBottom() {
    let bottom = 0;
    this.products.forEach(product => {
      bottom = Math.max(bottom, product.y + product.depth);
    });
    return bottom;
  }

  getWidth() {
    let width = 0;
    this.products.forEach(product => {
      width = Math.max(width, product.getWidth());
    });
    return width;
  }

  //TODO FIX THIS
  getHorizontalMiddle() {
    return this.x + this.getWidth() / 2;
  }

  getVerticalMiddle() {
    return (this.y + this.getBottom()) / 2;
  }

  getBottomProduct() {
    const products = [];
    this.products.forEach(product => {
      products.push(new Product(product));
    });
    products.sort((a, b) => {
      return a.z - b.z;
    });
    return products[0];
  }

  putAway() {
    this.products.forEach(product => {
      product.x = null;
      product.y = null;
      product.is_flipped = false;
      product.pallet_id = null;
    });
  }

  getTopZ() {
    let maxZ = 0;
    this.products.forEach(product => {
      maxZ = Math.max(product.z + product.getHeight());
    });
    return maxZ;
  }

  stackTop(anotherStack) {
    let currentZ = this.getTopZ();
    anotherStack.products.forEach(product => {
      product.z = currentZ;
      this.addToStack(product);
      currentZ += product.getHeight();
    });
  }

  flip() {
    if (this.products.length > 1) return;
    this.products[0].is_flipped = !this.products[0].is_flipped;
  }

  getHeight() {
    let height = 0;
    this.products.forEach(product => {
      height += product.getHeight();
    });
    return height;
  }

  getCanBeFlipped() {
    let canBeFlipped = true;
    this.products.forEach(product => {
      if (!product.can_be_flipped) {
        canBeFlipped = false;
      }
    });
    return canBeFlipped;
  }
}
